import AbstractHTML5Player from '../all/AbstractHTML5Player';
import * as  playerConstants from '../../utils/playerConstants';

class HisensePlayer extends AbstractHTML5Player {
  constructor() {
    super();
  }

  getStreamType() {
    switch(this.options.streamType) {
      case playerConstants.HLS:
        return 'application/vnd.apple.mpegurl';
        break;
      case playerConstants.AUDIO:
      case playerConstants.RADIO:
        return 'audio/mp4';
        break;
      case playerConstants.SS:
      case playerConstants.SS_MA:
        return 'application/vnd.ms-playready.initiator+xml';
        break;
      default:
        return null;
        break;
    }
  }

  setVideoSource(url, type) {
    console.log('******* <<<<<<<<<<< INIT hisense AbstractHTML5Player setVideoSource: ' + url);
    let source = document.createElement("source");
    source.src = url;

    console.log('ESV: setting stream type', this.options.streamType, this.getStreamType());
    type = this.getStreamType();
    if (type)
      source.type = type;

    source.id = "Html5PlayerSource" + (this.options.isPip ? '_pip' : '_full');
    this._playerHTMLTag.appendChild(source);

    console.log('******* <<<<<<<<<<< END hisense AbstractHTML5Player setVideoSource');
  }

  async getAudioTrackById() {
    const video = this._playerHTMLTag;
    const audioTracks = video && video.audioTracks;
    const textTracks = video && video.textTracks;

    // Conserva las referencias nativas para que enabled cambie el audio del video.
    this.audioTracks = audioTracks && audioTracks !== 'undefined' ? Array.prototype.slice.call(audioTracks) : [];
    this.textTracks = textTracks ? Array.prototype.slice.call(textTracks) : [];
    const audioIndex = this.audioTracks.findIndex((track) => track.enabled);
    const textIndex = this.textTracks.findIndex((track) => track.mode === 'showing');
    this.currentAudioTrackIndex = audioIndex >= 0 ? audioIndex : null;
    this.currentTextTrackIndex = textIndex >= 0 ? textIndex : null;

    // Resuelve también las listas vacías, sin devolver subtítulos como audios.
    return this.audioTracks;
  }

  setAudioTrackLive(codeTrack, subtitleTrack) {
    // El manifest identifica pistas sin idioma por su posición en audioTracks.
    const isIndex = typeof codeTrack === 'number'
      || (typeof codeTrack === 'string' && /^\d+$/.test(codeTrack));
    if (!isIndex) return super.setAudioTrackLive(codeTrack, subtitleTrack);

    const index = Number(codeTrack);
    if (this._isOnLoaded && this.audioTracks[index]) {
      for (let i = 0; i < this.audioTracks.length; i++) {
        if (i !== index) this.audioTracks[i].enabled = false;
      }
      this.audioTracks[index].enabled = true;
      this.currentAudioTrackIndex = index;
    }

    return super.setAudioTrackLive(null, subtitleTrack);
  }

  getAudioIndexOfCode(codeTrack) {
    return this.audioTracks.findIndex((track) => {
      console.log('[HISENSE track codes]',track.language);
      return this.getLanguageCodeByISO3(codeTrack) === track.language;
    });
  }
  loadMedia(){
    const blurEl = document.getElementById("blur");
    blurEl.classList.add("black");
    super.loadMedia();
  }
}

export default HisensePlayer;



// WEBPACK FOOTER //
// ./src/devices/hisense/Player.js